import { render } from "./serviceVue.vue?vue&type=template&id=1ad136f8"
import script from "./serviceVue.vue?vue&type=script&lang=js"
export * from "./serviceVue.vue?vue&type=script&lang=js"

import "../assets/css/besoins.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__